import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const AppButton = React.forwardRef(({
  variant = "ghost",
  fullWidth = false,
  className,
  size = "lg", // default | sm | lg | icon
  children,
  ...props
}, ref) => {
  let variantClasses = "";

  if (variant === "light") {
    variantClasses =
      "text-gray-700 border-white bg-white hover:bg-white hover:text-gray-900";
  } else if (variant === "gradient") {
    variantClasses =
      "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700";
  }

  return (
    <Button
      ref={ref}
      size={size}
      className={cn(fullWidth && "w-full", variantClasses, className)}
      {...props}
    >
      {children}
    </Button>
  );
});

AppButton.displayName = "AppButton";
